import styles from './index.module.css';

// TODO hold off rendering the image until it loads fully
const LazyImage = (props) => {
  return <img className={styles.Img} alt="" {...props} />;
};

export default LazyImage;
